module.exports = __webpack_public_path__ + "static/media/profile_joseph.389b224e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/profile_joseph.png
// module id = 1121
// module chunks = 4